import { __assign } from 'tslib';

var black = {
    "1": "#FDFDFD",
    "2": "#FBFBFB",
    "3": "#F9F9F9",
    "5": "#F4F4F4",
    "10": "#EAEAEA",
    "20": "#D5D5D5",
    "30": "#BFBFBF",
    "40": "#AAAAAA",
    "50": "#959595",
    "60": "#808080",
    "70": "#6B6B6B",
    "80": "#555555",
    "90": "#404040",
    "100": "#2B2B2B",
    shadow: "rgba(128, 128, 128, 0.2)",
    overlay: "rgba(43, 43, 43, 0.6)",
};
var primary = {
    "1": "#FCFDFF",
    "2": "#FAFCFE",
    "3": "#F7FAFE",
    "5": "#F2F7FD",
    "10": "#E6F0FB",
    "20": "#CCE0F6",
    "30": "#B3D1F2",
    "40": "#99C1ED",
    "50": "#80B2E9",
    "60": "#66A3E5",
    "70": "#4D93E0",
    "80": "#3384DC",
    "90": "#1A74D7",
    "100": "#0065D3",
    shadow: "rgba(0, 102, 204, 0.2)",
    overlay: "rgba(0, 102, 204, 0.6)",
};
var brandBlue = {
    "5": "#EAF7FF",
    "10": "#D4EFFF",
    "20": "#BDE6FF",
    "30": "#A4DEFF",
    "40": "#88D6FF",
    "50": "#67CEFF",
    "60": "#35C6FF",
    "70": "#20AEEE",
    "80": "#1096DB",
    "90": "#0B7FC8",
    "100": "#1268B3",
    gradient: "linear-gradient(180deg, #35C6FF 0%, #1268B3 100%);",
};
var brandOrange = {
    "5": "#FFEDE7",
    "10": "#FFDBCF",
    "20": "#FFC9B7",
    "30": "#FFB7A0",
    "40": "#FCA589",
    "50": "#F89373",
    "60": "#F3805D",
    "70": "#F27654",
    "80": "#F16C4C",
    "90": "#EF6144",
    "100": "#EE563D",
    gradient: "linear-gradient(180deg, #F3805D 0%, #EE563D 100%);",
};
var brandDark = {
    "5": "#FBFAFF",
    "10": "#F6F6FF",
    "20": "#E8E8FA",
    "30": "#D3D3E7",
    "40": "#BEBED4",
    "50": "#9898B3",
    "60": "#76758F",
    "70": "#5F5E7C",
    "80": "#484769",
    "90": "#313057",
    "100": "#1A1944",
    gradient: "linear-gradient(180deg, #76758F 0%, #1A1944 100%);",
};
var brandPurple = {
    "5": "#F2E0EE",
    "10": "#E5C1DE",
    "20": "#D8A3CD",
    "30": "#C985BD",
    "40": "#BA66AD",
    "50": "#AA459D",
    "60": "#9A1A8D",
    "70": "#881890",
    "80": "#741994",
    "90": "#5C1C96",
    "100": "#3E1F98",
    gradient: "linear-gradient(180deg, #9A1A8D 0%, #3E1F98 100%);",
};
var success = {
    "5": "#EEFEFA",
    "10": "#CCFBF1",
    "20": "#B0EEE1",
    "30": "#93E0D2",
    "40": "#74D3C3",
    "50": "#50C5B4",
    "60": "#14B8A6",
    "70": "#139C8F",
    "80": "#148177",
    "90": "#146761",
    "100": "#134E4A",
    shadow: "rgba(20, 184, 166, 0.2)",
    overlay: "rgba(20, 184, 166, 0.6)",
};
var warning = {
    "5": "#FFF9F1",
    "10": "#FFEDD5",
    "20": "#FDD8AB",
    "30": "#FCC184",
    "40": "#FBAA5F",
    "50": "#FA903C",
    "60": "#F97316",
    "70": "#EB6614",
    "80": "#DE5A11",
    "90": "#D04D0F",
    "100": "#C2410C",
    shadow: "rgba(249, 115, 22, 0.2)",
    overlay: "rgba(249, 115, 22, 0.6)",
};
var critical = {
    "5": "#FFF5F5",
    "10": "#FEE2E2",
    "20": "#FFC5C4",
    "30": "#FFA7A4",
    "40": "#FE8885",
    "50": "#F86864",
    "60": "#EF4444",
    "70": "#D93534",
    "80": "#CE2D2C",
    "90": "#C42524",
    "100": "#B91C1C",
    shadow: "rgba(239, 68, 68, 0.2)",
    overlay: "rgba(239, 68, 68, 0.6)",
};
var legacyPalette = {
    // @deprecated: use box-shadow semantic
    shadow: black.shadow,
    // @deprecated: use text-main semantic
    text: black["100"],
    // @deprecated: use box-background semantic
    background: "#FFFFFF",
    white: "#FFFFFF",
    primary: primary,
    black: black,
    success: success,
    warning: warning,
    critical: critical,
    brandBlue: brandBlue,
    brandOrange: brandOrange,
    brandDark: brandDark,
    brandPurple: brandPurple,
    focus: {
        shadow: "rgba(0, 102, 204, 0.2)",
    },
};
// Feedback
// Describes non-interactive containers for the purpose of indicating a system state to the user, eg. banners, badges, notifications.
var feedbackSemantics = {
    "feedback-error-foreground": critical["60"],
    "feedback-critical-onsurface": critical["60"],
    "feedback-critical-surface": critical["10"],
    "feedback-success-onsurface": success["60"],
    "feedback-success-surface": success["10"],
    "feedback-warning-onsurface": warning["60"],
    "feedback-warning-surface": warning["10"],
    "feedback-information-onsurface": primary["60"],
    "feedback-information-surface": primary["10"],
    "feedback-neutral-onsurface": black["60"],
    "feedback-neutral-surface": black["10"],
};
// Control
// Describes interactive containers for the purpose of inputting information, eg. `<input/>`
var controlSemantics = {
    "control-onsurface": black["100"],
    "control-surface": "#ffffff",
    "control-disabled-onsurface": black["100"],
    "control-disabled-surface": black["5"],
    "control-border": black["20"],
    "control-focus-border": primary["100"],
    "control-focus-outline": primary["20"],
};
// Text
// Describes all use of typography
var textSemantics = {
    "text-main": black["100"],
    "text-secondary": black["60"],
    // Not implemented yet:
    // "text-placeholder": black["40"],
};
// Box
// Describes generic non-interactive containers, eg. `<body/>.`
var boxSemantics = {
    "box-background": black["5"],
    "box-background-layer-1": "#ffffff",
    "box-background-layer-2": primary["20"],
    "box-border": black["10"],
    "box-shadow": black.shadow,
};
// Action
// Describes interactive containers, eg. `<button/>.`
var actionSemantics = {
    // Foreground: ie. Links
    "action-foreground": primary["100"],
    // Primary
    "action-primary-onsurface": "#ffffff",
    "action-primary-surface": primary["100"],
    "action-primary-border": primary["100"],
    "action-primary-shadow": "rgba(0, 102, 204, 0.2)",
    // Secondary
    "action-secondary-onsurface": primary["100"],
    "action-secondary-surface": "#ffffff",
    "action-secondary-border": primary["100"],
    "action-secondary-shadow": "rgba(128, 128, 128, 0.2)",
    // Tertiary
    "action-tertiary-onsurface": primary["100"],
    "action-tertiary-surface": primary["5"],
    "action-tertiary-border": primary["5"],
};
var colors = __assign(__assign(__assign(__assign(__assign(__assign({}, legacyPalette), actionSemantics), textSemantics), feedbackSemantics), controlSemantics), boxSemantics);

export { colors };
//# sourceMappingURL=colors.js.map
